import { MainLoader, ResourceLoader } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountResourceInfo } from '../AccountResource/AccountResource';
import LoginInformation from '../AccountResource/LoginInformation';
import { StyledTile } from './AccountTile.styles';

export interface AccountTileProps { }

const AccountTile: FC<AccountTileProps> = () => {
  const { t } = useTranslation('Account');

  return (
    <StyledTile data-testid="accountTile" title={t('title')} isDivided>
      <ResourceLoader
        resourceSrc={AccountResourceInfo.name}
        buttonAlign="left"
        inlineErrorMessage={false}
        CustomLoader={MainLoader}
      >
        <LoginInformation />
      </ResourceLoader>
    </StyledTile>
  );
};

export default AccountTile;
